import { useEffect, useState } from "react";
import { callAPI } from "../../lib/common";
// Language is used to reload the packages on language change
export default (pictureSet, language = "") => {
    const [packageInfo, setPackageInfo] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        if (!pictureSet) {
            return;
        }
        setIsLoading(true);
        console.log("Fetching new package list", pictureSet);
        callAPI("/ajax/prophoto/get_packages.php?uuid=" + pictureSet.subject.uuid).then((data) => {
            console.log("Loading package list complete");
            setIsLoading(false);
            setPackageInfo(data);
        });
    }, [pictureSet, language]);
    return {
        packageInfo,
        isLoading,
    };
};
